import React, {useEffect, useRef, useState} from 'react';
import Form from "../ass_form_components/Form"
import ProgressBar from "../ass_form_components/ProgressBar"
import { FormProvider } from '../context/FormContext'
import BreadCrumb from '../ass_components/BreadCrumb'
import Meta from '../ass_components/Meta'

import { useDispatch, useSelector } from 'react-redux';
import useFormContext from "../hooks/useFormContext"
import {translate} from "../i18n";
import {useNavigate} from "react-router-dom";
import {addFiles, removeFile, resetForm} from "../store/reducers/registrationSlice";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import {editUserType, resetUserType} from "../store/reducers/userTypeSlice";

const HeroPackSignUp = () => {
  const dispatch = useDispatch();
  const {
    userType,
    type
  } = useSelector(state => state.userType);
  const language_code = useSelector(state => state.lang);
  const actualCountry = useSelector((state) => state.country.country);
  const countryCode = actualCountry && actualCountry.value
      ? actualCountry.value.toLowerCase()
      : 'tg';

  useEffect(() => {
    dispatch(editUserType('hero'));

  }, []);

  useEffect(() => {
    dispatch(editUserType('hero'));
  }, [actualCountry]);
  return (
    <>
    <Meta title={"Business"}/>
    <BreadCrumb title='PACK AGRI HERO'/>
    <div className='wishlist-wrapper assiganto-home-wrapper-2 py-3'>
    <div className='container-xxl'>
    <FormProvider>
      <ProgressBar />
      <Form />
    </FormProvider>
    </div>
    </div>
    </>
  )
}
export default HeroPackSignUp